export default __webpack_public_path__ + "static/media/Red_s Powers.3e18f12e.jpg";